module.exports = __webpack_public_path__ + "media/images/info-icon-3aac3fbf37260a8431f7dacd1dd3e9c6.svg";